'use strict';

import Cupido from './Cupido';
import Guardian from './Guardian';
import Werewolf from './Werewolf';
import Witch from './Witch';
import Seer from './Seer';
import Hunter from './Hunter';
import Idiot from './Idiot';
import Villager from './Villager';
import Uncertain from './Uncertain';

export default {
  Cupido,
  Guardian,
  Werewolf,
  Witch,
  Seer,
  Hunter,
  Idiot,
  Villager,
  Uncertain
};



/** WEBPACK FOOTER **
 ** ./scripts/models/roles/index.jsx
 **/